export default [
    {
        path: '/',
        meta: {
            requiresAuth: true,
            role: 'admin',
            layout: 'AdminLayout',
        },
        children: [
            {
                path: '/admin-earival-dashboard',
                name: 'admin-earival-dashboard',
                component: () => import('@/Pages/AdminEArrival/Dashboard.vue'),
            },
            {
                path: "/admin-earival-data",
                component: () => import("@/Pages/AdminEArrival/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "admin-earival-data",
                        component: () => import("@/Pages/AdminEArrival/List.vue"),
                    },
                    {
                        path: ":id",
                        name: "admin-earival-data-show",
                        component: () => import("@/Pages/AdminEArrival/Show.vue"),
                    }
                ],
            },
            {
                path: "/admin-earival-sea-data",
                component: () => import("@/Pages/AdminEArrival/SeaData/Index.vue"),
                children: [
                    {
                        path: "",
                        name: "admin-earival-sea-data",
                        component: () => import("@/Pages/AdminEArrival/SeaData/List.vue"),
                    },
                    {
                        path: "create",
                        name: "admin-earival-sea-data-create",
                        component: () =>
                            import("@/Pages/AdminEArrival/SeaData/Create.vue"),
                    }
                ],
            },
        ],
    },
];
